import { useApp } from "../context";
import { badgeClass, today } from "../lib/engine";

const slug = t => String(t).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const Badge = ({ text, testId }) => (
  <span className={`pill ${badgeClass(text)}`} data-testid={testId}>{text}</span>
);

export const Heading = ({ title, description, children }) => (
  <div className="heading">
    <div>
      <div className="muted" style={{ fontSize: 11 }}>PAN INDIA OPERATIONS · {today()}</div>
      <h1 data-testid="page-title">{title}</h1>
      <p className="muted">{description}</p>
    </div>
    {children}
  </div>
);

export const Metric = ({ label, value, note }) => (
  <div className="card" data-testid={`metric-${slug(label)}`}>
    <div className="label">{label}</div>
    <div className="value" data-testid={`metric-${slug(label)}-value`}>{value}</div>
    <small>{note}</small>
  </div>
);

export const Table = ({ headers, children, testId }) => {
  const empty = !children || (Array.isArray(children) && children.length === 0);
  return (
    <div className="table-wrap">
      <table data-testid={testId}>
        <thead><tr>{headers.map(h => <th key={h}>{h}</th>)}</tr></thead>
        <tbody>
          {empty ? (
            <tr><td colSpan={headers.length} className="empty">No records found.</td></tr>
          ) : children}
        </tbody>
      </table>
    </div>
  );
};

export const CaseLink = ({ c }) => {
  const { openModal } = useApp();
  return (
    <>
      <button className="link" data-testid={`case-link-${c.id}`} onClick={() => openModal({ type: "case", id: c.id })}>
        {c.id}
      </button>
      <small>{c.disb}</small>
    </>
  );
};

export const NewCaseButton = () => {
  const { openModal, actor } = useApp();
  return (
    <button className="primary" data-testid="new-case-btn" disabled={actor !== "maker"}
      title={actor !== "maker" ? "Operations maker account required" : undefined} onClick={() => openModal({ type: "new" })}>
      + New loan case
    </button>
  );
};

export const Filters = () => {
  const { state, search, setSearch, region, setRegion } = useApp();
  const cities = [...new Set(state.cases.map(c => c.city))];
  return (
    <div className="toolbar">
      <input
        data-testid="search-input" aria-label="Search records"
        placeholder="Search case, borrower, DSA or bank"
        value={search} onChange={e => setSearch(e.target.value)}
      />
      <select data-testid="region-select" aria-label="Region" style={{ maxWidth: 180 }}
        value={region} onChange={e => setRegion(e.target.value)}>
        <option>All regions</option>
        {cities.map(city => <option key={city}>{city}</option>)}
      </select>
    </div>
  );
};
